import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import Masonry from "masonry-layout";
document.addEventListener('DOMContentLoaded', function () {
    var swiperHeader = new Swiper('.carousel-header .swiper', {
        modules: [Autoplay, Pagination, EffectFade],
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        speed: 500,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
    var swiperPages = new Swiper('.children-pages .swiper', {
        modules: [Autoplay, Navigation],
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        slidesPerView: 1,
        breakpoints: {
            768: {
                slidesPerView: 2,
            }
        },
        spaceBetween: 20,
        direction: 'horizontal',
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
    var swiperLogos = new Swiper('.logos-container .swiper', {
        modules: [Autoplay, Navigation],
        autoplay: {
            delay: 1,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
        },
        slidesPerView: 4,
        breakpoints: {
            720: {
                slidesPerView: 6,
            },
            960: {
                slidesPerView: 8,
            },
            1200: {
                slidesPerView: 10,
            }
        },
        spaceBetween: 20,
        direction: 'horizontal',
        loop: true,
        freeMode: true,
        speed: 1000
    });
    var el = document.querySelectorAll('.image-text-blocks');
    if (el != null && el.length > 0) {
        var msnry = new Masonry('.image-text-blocks .row');
    }
}, false);
